import { z } from 'zod/v4';
export var ToolName;
(function (ToolName) {
    ToolName["SearchTools"] = "SEARCH_TOOLS";
    ToolName["GetTool"] = "GET_TOOL";
    ToolName["ListPendingProposals"] = "LIST_PENDING_PROPOSALS";
    ToolName["EscalateToHuman"] = "ESCALATE_TO_HUMAN";
    ToolName["ReportOutcome"] = "REPORT_OUTCOME";
    ToolName["GetCustomer"] = "GET_CUSTOMER";
    ToolName["GetCreditor"] = "GET_CREDITOR";
    ToolName["GetWorkflow"] = "GET_WORKFLOW";
    ToolName["GetCurrentPaymentPlan"] = "GET_CURRENT_PAYMENT_PLAN";
    ToolName["SearchCaseHistory"] = "SEARCH_CASE_HISTORY";
    ToolName["SearchContactPersons"] = "SEARCH_CONTACT_PERSONS";
    ToolName["SearchProperties"] = "SEARCH_PROPERTIES";
    ToolName["SearchInteractions"] = "SEARCH_INTERACTIONS";
    ToolName["GetInteraction"] = "GET_INTERACTION";
    ToolName["SearchVouchers"] = "SEARCH_VOUCHERS";
    ToolName["GetVoucher"] = "GET_VOUCHER";
    ToolName["SearchTemplates"] = "SEARCH_TEMPLATES";
    ToolName["GetTemplate"] = "GET_TEMPLATE";
    ToolName["SearchMentions"] = "SEARCH_MENTIONS";
    ToolName["SearchUpdateTypes"] = "SEARCH_UPDATE_TYPES";
    ToolName["GetUpdateType"] = "GET_UPDATE_TYPE";
    ToolName["SearchUpdates"] = "SEARCH_UPDATES";
    ToolName["GetUpdate"] = "GET_UPDATE";
    ToolName["SearchDocuments"] = "SEARCH_DOCUMENTS";
    ToolName["GetDocument"] = "GET_DOCUMENT";
    ToolName["GetFile"] = "GET_FILE";
    ToolName["SearchPaymentPlans"] = "SEARCH_PAYMENT_PLANS";
    ToolName["GetPaymentPlan"] = "GET_PAYMENT_PLAN";
    ToolName["SearchTribunalCases"] = "SEARCH_TRIBUNAL_CASES";
    ToolName["GetTribunalCase"] = "GET_TRIBUNAL_CASE";
    ToolName["CreateInteraction"] = "CREATE_INTERACTION";
    ToolName["CreateCreditorMessage"] = "CREATE_CREDITOR_MESSAGE";
    ToolName["CreatePaymentPlan"] = "CREATE_PAYMENT_PLAN";
    ToolName["CreateUpdate"] = "CREATE_UPDATE";
    ToolName["EndCase"] = "END_CASE";
})(ToolName || (ToolName = {}));
export const ToolNameSchema = z.enum(ToolName);
export var ToolCategory;
(function (ToolCategory) {
    ToolCategory["Meta"] = "META";
    ToolCategory["CaseInfo"] = "CASE_INFO";
    ToolCategory["Interactions"] = "INTERACTIONS";
    ToolCategory["Templates"] = "TEMPLATES";
    ToolCategory["Documents"] = "DOCUMENTS";
    ToolCategory["Vouchers"] = "VOUCHERS";
    ToolCategory["CaseManagement"] = "CASE_MANAGEMENT";
    ToolCategory["Tribunal"] = "TRIBUNAL";
})(ToolCategory || (ToolCategory = {}));
export var ToolWeight;
(function (ToolWeight) {
    ToolWeight["Light"] = "LIGHT";
    ToolWeight["Heavy"] = "HEAVY";
    ToolWeight["Terminal"] = "TERMINAL";
})(ToolWeight || (ToolWeight = {}));
export var ToolPolicy;
(function (ToolPolicy) {
    ToolPolicy["Disabled"] = "DISABLED";
    ToolPolicy["RequireApproval"] = "REQUIRE_APPROVAL";
    ToolPolicy["AutoRun"] = "AUTO_RUN";
})(ToolPolicy || (ToolPolicy = {}));
export var ProposalDecision;
(function (ProposalDecision) {
    ProposalDecision["Pending"] = "PENDING";
    ProposalDecision["ApprovedAsIs"] = "APPROVED_AS_IS";
    ProposalDecision["Edited"] = "EDITED";
    ProposalDecision["Rejected"] = "REJECTED";
    ProposalDecision["Failed"] = "FAILED";
    // Stale, superseded or dismissed: closed without a caseworker judging the content.
    ProposalDecision["Closed"] = "CLOSED";
})(ProposalDecision || (ProposalDecision = {}));
//# sourceMappingURL=types.js.map